import { ControlType } from 'utility/constant'

export const extractMultiChoiceQuestions = template => {
    const sections = template?.Sections || []
    const questions = []
    sections.forEach(section => {
        const sectionQuestions = section.Questions || []
        sectionQuestions.forEach(q => {
            if (Number(q.QuestionResponseId) !== ControlType.MulltiResponse) {
                return
            }
            const multiAnswers =
                q.MultiAnswers ||
                q.Answers?.MultipleResponse ||
                q.MultipleAnswers ||
                []
            questions.push({
                questionId: q.Id,
                questionText: q.QuestionText || q.DisplayText || 'Untitled',
                sectionName: section.SectionName || section.Name || '',
                masterListId: q.MasterListId ?? q.masterListId ?? null,
                multiAnswers: Array.isArray(multiAnswers) ? multiAnswers : [],
                displaySetting: q.QuestionDisplaySetting || {},
            })
        })
    })
    return questions
}

export const formatInlineOptions = multiAnswers =>
    (multiAnswers || []).map(a => ({
        text: a.DisplayText ?? a.displayText ?? a.Response ?? '',
        score: a.Score ?? a.score ?? 0,
    }))
